import React, { Fragment } from 'react'
import numeral from 'numeral'
import { number, string } from 'prop-types'
import {
  TagComponent, Icon, WalletIcon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

function Price({
  discount,
  originalPrice,
  price,
  ribbon = null,
}) {
  const isFreeModel = discount === 0 && originalPrice === 0

  const getPrice = (value, format = '$0.00') => {
    return numeral(value).format(format)
  }

  function renderDiscountTag() {
    if (discount !== 0) {
      return (
        <TagComponent
          type="primary"
          color="warning"
        >
          -{getPrice(discount, '0%')}
        </TagComponent>
      )
    }

    if (ribbon) {
      return (
        <TagComponent
          type="primary"
          color="primary"
          leadIcon={<Icon svgComponent={WalletIcon} />}
        />
      )
    }

    return null
  }

  function renderPrice() {
    return (
      <Fragment>
        {discount > 0 && (
          <span className="short-model-info__original-price cgt-legacy-color-typography-disabled">
            {getPrice(originalPrice)}
          </span>
        )}
        <span className="short-model-info__current-price cgt-legacy-heading-h6">
          {isFreeModel ? 'FREE' : getPrice(price).replace('.00', '')}
        </span>
      </Fragment>
    )
  }

  return (
    <div className="short-model-info__price">
      {renderPrice()}
      {renderDiscountTag()}
    </div>
  )
}

Price.propTypes = {
  discount: number.isRequired,
  originalPrice: number.isRequired,
  price: number.isRequired,
  ribbon: string,
}

export default Price
